import { IGetAdesaoTable, ItenAdesao } from "services/NGT/EffectiveConsolidation"

import { FormatNumber } from "../../Shared/FormatNumber"

export class FormatAdhesionTableData {

  static formatarNumero(numero: number) {
    return FormatNumber.formatarNumero(numero);
  }

  static formatarTableData(tableData: IGetAdesaoTable) {
    if (tableData) {
      tableData.itensConsolidacao.map(
        (item) => (item.totalizadores = this.mapTableDataItem(item.totalizadores))
      )
    }
  }
  static formatarSubItens(tableData: IGetAdesaoTable) {
    if (tableData) {
      tableData.itensConsolidacao.map(
        (item) =>
          (item.itens = item.itens.map((subitem) => this.mapTableDataItem(subitem)))
      )
    }
  }

  static mapTableDataItem(item: ItenAdesao) {
    return {
      dsConsolidacao: item.dsConsolidacao,
      qtMobilizacaoMensal: this.formatarNumero(item.qtMobilizacaoMensal) as unknown as number,
      qtFornecedor: this.formatarNumero(item.qtFornecedor) as unknown as number,
      nmUnidade: item.nmUnidade,
      idUnidadeGestora: item.idUnidadeGestora,
      idConsolidacao: item.idConsolidacao,
      qtContratoPrincipal: this.formatarNumero(item.qtContratoPrincipal) as unknown as number,
      qtSubContrato: this.formatarNumero(item.qtSubContrato) as unknown as number,
      qtTotalContratos: this.formatarNumero(item.qtTotalContratos) as unknown as number,
      qtTotalContrapartes: this.formatarNumero(item.qtTotalContrapartes) as unknown as number,
      qtContraparteNaoPreencheu: this.formatarNumero(item.qtContraparteNaoPreencheu) as unknown as number,
      peContrapartes: this.formatarNumero(item.peContrapartes) as unknown as number
    }
  }
}
